import { motion } from 'framer-motion'
import { GitHub, Linkedin } from 'react-feather'
import './Team.css'

import lh from '../../assets/lh.jpg'
import ch from '../../assets/ch.jpeg'

export default function Team() {
  const founders = [
    {
      name: 'Chamidu Rathnayaka',
      role: 'CEO & Founder',
      image: ch,
      bio: 'Visionary leader and technical expert driving innovation at Evoaxy Solutions.',
      social: {
        linkedin: 'https://www.linkedin.com/in/rm-chamidu/',
        github: 'https://github.com/Chamidu-Maduwantha'
      }
    },
    {
      name: 'Lahiru Suwahas',
      role: 'CEO & Founder',
      image: lh,
      bio: 'Strategic leader focused on delivering exceptional software solutions.',
      social: {
        linkedin: 'https://www.linkedin.com/in/lahiru-suwahas-9ab43920b/',
        github: 'https://github.com/snafal'
      }
    }
  ]

  return (
    <section className="team-section" id='team'>
      <div className="team-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="team-header"
        >
          <h2>Meet Our <span className="gradient-text">Founders</span></h2>
          <p>The visionaries behind Evoaxy Solutions</p>
        </motion.div>

        <div className="founders-grid">
          {founders.map((founder, index) => (
            <motion.div
              key={founder.name}
              className="founder-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              <div className="founder-image-wrapper">
                <img src={founder.image} alt={founder.name} className="founder-image" />
              </div>
              <div className="founder-info">
                <h3>{founder.name}</h3>
                <span className="founder-role">{founder.role}</span>
                <p className="founder-bio">{founder.bio}</p>
                <div className="founder-social">
                  <a 
                    href={founder.social.linkedin} 
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Linkedin size={20} />
                  </a>
                  <a 
                    href={founder.social.github} 
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <GitHub size={20} />
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

